module.exports = __webpack_public_path__ + "img/artforcancer.0d6d4778.png";